import React, { Fragment, useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Form, FormGroup, Label, Row } from "reactstrap";
import * as yup from "yup";
import ModalFormSubmit from "../../../../share-components/form/modalFormSubmit";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import PreLoader from "../../../../share-components/ui/preLoader";
import { closeRateDialog, getCourierCarriers, openRateEditDialog, selectRateDialog, updateCourierCarrier } from "../../store/courierRateSlice";
import { COURIER_COST_PERMISSION, NEW_ORDERS_ONLY_NOTE, RateInfoNote, rateField } from "./courierCostShared";

const DIALOG_KEY = "carriers";

const defaultValues = { id: "", name: "", key: "", rate: "", return_rate: "" };

const schema = yup.object().shape({
  rate: rateField("Outbound rate"),
  return_rate: rateField("Return rate"),
});

function CarrierDefaultsTab() {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [tableLoading, setTableLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const currentUser = useSelector(({ authReducer }) => authReducer.data.user);
  const carriers = useSelector(({ partner }) => partner.courierRate.carriers);
  const canManage = currentUser.permission.includes(COURIER_COST_PERMISSION);

  const { handleSubmit, formState, reset, register, setValue, getValues } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { errors } = formState;

  useEffect(() => {
    getData();
  }, [dispatch, name]);

  const getData = () => {
    setTableLoading(true);
    dispatch(getCourierCarriers({ name })).then(() => setTableLoading(false));
  };

  const tableColumns = [
    { name: "Courier", selector: (row) => row.name, sortable: true, left: true },
    { name: "Key", selector: (row) => row.key, sortable: true, left: true },
    { name: "Default Outbound Rate", selector: (row) => row.rate, sortable: true, right: true },
    { name: "Default Return Rate", selector: (row) => row.return_rate, sortable: true, right: true },
  ];

  const closeDialog = () => dispatch(closeRateDialog(DIALOG_KEY));

  const onSubmitForm = (dialog, data) => {
    setButtonDisable(true);
    dispatch(updateCourierCarrier({ id: data.id, rate: data.rate, return_rate: data.return_rate })).then((res) => {
      setButtonDisable(false);
      getData();
      if (!res.error) closeDialog();
    });
  };

  return (
    <Fragment>
      <div className="product-grid">
        <div className="feature-products">
          <Row>
            <Col sm="12">
              <Form>
                <FormGroup className="m-0">
                  <input onChange={(e) => setName(e.target.value)} type="text" className="form-control border" placeholder="Search By Courier" />
                  <i className="fa fa-search"></i>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
      <Card>
        <CardBody>
          <RateInfoNote>
            Fallback used when no service cost or shipping-method rate matches the order. {NEW_ORDERS_ONLY_NOTE}
          </RateInfoNote>
          {tableLoading ? (
            <div style={{ minHeight: 400 }}>
              <PreLoader />
            </div>
          ) : (
            <div className="table-responsive product-table mt-4">
              <CommonDataTable
                headerColumns={tableColumns}
                gridData={carriers}
                pagination
                onEdit={canManage ? (row) => dispatch(openRateEditDialog({ key: DIALOG_KEY, data: row })) : ""}
              />
            </div>
          )}
        </CardBody>
      </Card>

      <ModalFormSubmit
        defaultValues={defaultValues}
        schema={schema}
        onSubmitForm={onSubmitForm}
        reset={reset}
        formState={formState}
        handleSubmit={handleSubmit}
        title="Carrier Default Rates"
        selector="partner"
        dialog={selectRateDialog(DIALOG_KEY)}
        closeDialog={closeDialog}
        setValue={setValue}
        getValues={getValues}
        buttonDisable={buttonDisable}
      >
        <Row>
          <Col>
            <FormGroup>
              <Label className="col-form-label">Courier</Label>
              <input type="text" {...register("name")} className="form-control" readOnly />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <FormGroup>
              <Label className="col-form-label">Default Outbound Rate (£)</Label>
              <input type="number" step="0.01" min="0" {...register("rate")} className={`form-control ${errors.rate ? "is-invalid" : ""}`} />
              <div className="invalid-feedback">{errors.rate?.message}</div>
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup>
              <Label className="col-form-label">Default Return Rate (£)</Label>
              <input type="number" step="0.01" min="0" {...register("return_rate")} className={`form-control ${errors.return_rate ? "is-invalid" : ""}`} />
              <div className="invalid-feedback">{errors.return_rate?.message}</div>
            </FormGroup>
          </Col>
        </Row>
        <RateInfoNote>{NEW_ORDERS_ONLY_NOTE}</RateInfoNote>
      </ModalFormSubmit>
    </Fragment>
  );
}

export default CarrierDefaultsTab;
